<template>
  <div id="login">
    <div class="login-div">
      <!--			<div class="login-wrap">-->
      <!--				<img src="../../assets/images/login/logo.png">-->
      <!--				<div class="form-text">钢轨表面缺陷检测系统</div>-->
      <!--			</div>-->
      <div class="login-input-wrap">
        <div class="input-wrap-bg-top"></div>
        <div class="input-text">用户{{ type == 'register' ? '注册' : type == 'retrieve_password' ? '忘记密码' : '登录' }}</div>
        <div class="input-user">
          <!--          <span>手机号</span>-->
          <el-input type="text" placeholder="手机号" v-model="mobile" size="medium "></el-input>
        </div>
        <div class="psdcls-getcode" v-show="type == 'register' || type ==  'retrieve_password'">
          <el-input
              size="medium"
              v-model="messageCode"
              auto-complete="off"
              placeholder="短信验证码"
          >
          </el-input>

          <el-button class="get-code" @click="getCheckNum()" size="medium">
            {{ !codeTime ? '获取验证码' : codeTime + 's' }}
          </el-button>
        </div>
        <div class="psdcls">
          <!--          <span>密码</span>-->
          <el-input type="password" placeholder="密码" v-model="password" size="medium"></el-input>
        </div>
        <div class="psdcls" v-show="type == 'register' || type ==  'retrieve_password'">
          <!--        					<span>确认密码</span>-->
          <el-input type="password" placeholder="确认密码" v-model="password2" size="medium "></el-input>
        </div>
        <div v-show="type=='login'" style="text-align: left;margin-top: 10px;width: 78%;margin: 10px auto;">
          <el-checkbox v-model="checked" @change="pwdSelChange">记住密码</el-checkbox>
        </div>

        <div class="loginbutton">
          <el-button type="primary" @click="login" @keyup.enter.native="login" size="small">
            {{ type == 'register' ? '立即注册' : type == 'retrieve_password' ? '重置密码' : '立即登录' }}
          </el-button>
        </div>
        <div class="input-bottom-wrap">
          <span v-show="type=='login'" @click="type='retrieve_password'">忘记密码</span>
          <span @click="type='register'" v-show="type != 'register'">立即注册</span>
          <span v-show="type!='login'"
                @click="type='login'">立即登录</span>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import {
  register,
  set_code,
  login,
  resetPassword,
  getUserInfo, payStatus
} from "@/api/api.js";
import {Loading} from "element-ui";

export default {
  name: 'login',
  data() {
    return {
      mobile: "",
      password: "",
      password2: '',
      code: '',
      messageCode: '',
      checked: this.$store.state.remPwdObj.rem,
      // dialogVisible: false,
      codeTime: 0,
      // retrieve:false,
      type: 'register',     //注册 register, 忘记密码retrieve_password

    };
  },
  created() {
    let that = this;
    document.onkeydown = function (e) {
      var key = '';
      if (window.event == undefined) {
        key = e.keyCode;
      } else {
        key = window.event.keyCode;
      }
      if (key == 13) {
        that.login();
      }
    }
    console.log(this.$store.state.isLogin);
    console.log(this.$store.state.auth.token);
    //登录直接跳转首页
    if (this.$store.state.isLogin == true && this.$store.state.auth.token !='') {
      // this.$router.push('/home')
    }
  },
  mounted() {
    if(this.$store.state.remPwdObj.rem) {
      this.password = this.$store.state.remPwdObj.pwd
      this.mobile = this.$store.state.remPwdObj.mobile
    }
  },
  methods: {
    login() {
      let that = this;
      let params = {}
      if (this.getMobile()) {
        params.mobile = this.getMobile()
      } else {
        return;
      }
      if (!this.password) {
        this.$message.warning('请输入密码')
        return;
      } else {
        params.password = this.password
      }
      if (this.type == 'register' || this.type == 'retrieve_password') {
        if (!this.password2) {
          that.$message.warning('请输入确认密码')
          return;
        } else if (this.password2 == this.password) {
          params.r_password = this.password2
        } else {
          that.$message.warning('两次密码不一致，请重新输入')
          return
        }
        if (!this.messageCode) {
          that.$message.warning('请输入验证码')
          return
        } else {
          params.code = this.messageCode
        }
        // 注册
        if (this.type == 'register') {
          register(params).then(res => {
            if (res.code == 1) {
              that.$message.success(res.msg)
              that.type = 'login'
            } else {
              that.$message.error(res.msg)
            }
          }).catch(function (err) {
            console.log(err)
            that.$message.error(err.msg)
          })
        } else {
          // 忘记密码
          resetPassword(params).then(res => {
            if (res.code == 1) {
              that.$message.success(res.msg)
              that.type = 'login'
            } else {
              that.$message.error(res.msg)
            }
          }).catch(function (err) {
            // console.log(error.data)
            that.$message.error(err.msg)
          })
        }

      } else {
        // 登录
        let loadingInstance = Loading.service({background:'rgba(0,0,0,0.7)'});
        login(params).then(res => {
          // console.log(res)
          loadingInstance.close();
          if (res.code == 1) {
            if(that.checked) {
              let obj = {
                pwd:this.password,
                mobile:this.mobile
              }
              that.$store.commit('SET_PWD',obj)

            }
            that.$store.commit('SET_AUTH', res.data.token);
            if (res.data.status === 1) {
              this.getUserInfo()

              // that.$store.commit('SET_AUTH', res.data.token);
              // console.log(that.$store.state.auth, ' /\n')
            } /*else {
              that.openPayModal = true
              that.url = res.data.pay_code
              that.price = res.data.price
              that.order_no = res.data.order_no
              this.paySetInterval = setInterval(()=> {
                that.payStatus().then(res=> {
                  // console.log(res,'res')
                  if(res.code==1) {
                    that.$message.success(res.msg)
                    that.$store.commit('SET_ISLOGIN', true);
                    // that.$store.commit('SET_AUTH', res.data.token);
                    // console.log(that.$store.state.auth, ' /\n')
                    this.getUserInfo()
                    clearInterval(this.paySetInterval);
                    that.$router.push('/home')
                  }
                }).catch(function (err) {
                  console.log(err)
                })
              },2000)
            }*/
          } else {
            loadingInstance.close();
            // that.$message.error(res.message)
          }
        }).catch(function (err) {
          // console.log(err)
          loadingInstance.close();
          that.$message.error(err.msg)
        })
      }
    },
    getMobile() {
      var mobile = '';
      if (!(/^1[3|4|5|7|8][0-9]{9}$/.test(this.mobile))) {
        this.$message.warning("手机号码有误，请重填")
        return false;
      } else {
        mobile = this.mobile;
      }
      return mobile;
    },
    getCheckNum: function () {
      if (!this.getMobile()) {
        return;
      }
      if (this.codeTime > 0) {
        this.$message.warning('不能重复获取')
        return false;
      } else {
        this.codeTime = 60
        let timer = setInterval(() => {
          this.codeTime--;
          if (this.codeTime < 1) {
            clearInterval(timer);
            this.codeTime = 0
          }
        }, 1000)
        this.loginGetCode()
      }
    },
    // 获取验证码
    loginGetCode() {
      let params = {};
      params.mobile = this.getMobile()
      params.type = this.type
      set_code(params).then(res => {
        console.log(res, 'res')
        this.$message.success('获取验证码成功')
      }).catch(err => {
        console.error('is catch', err)
      })
    },
    getUserInfo() {
      getUserInfo({token: this.$store.state.auth.token}).then(res => {
        // console.log(res)
        if (res.code == 1) {
          this.$message.success('登录成功')
          this.$store.commit('SET_ISLOGIN', true);
          this.$store.commit('SET_USERINFO', res.data)
          this.$router.push('/home')
        }else if(res.code == -4){
          this.$store.commit('SET_ISLOGIN', false);
        }
      }).catch(function (err) {
        console.log(err)
      })
    },
    payStatus() {
      return new Promise((res,rej)=> {
        payStatus({token: this.$store.state.auth.token,order_no:this.order_no}).then(respore => {
          // console.log(respore)
          if (respore.code == 1) {
            res(respore)

          }
        }).catch(function (err) {
          // console.log(err)
          rej(err)
        })
      })

    },
    // 记住密码
    pwdSelChange(val) {
      console.log(val)
      this.$store.commit('SET_REMPWD',val)
    }

  }
};
</script>
<style lang="less" scoped>
html,
body,
#app,
#login {
  width: 100%;
  height: 100%;
  background: url('../../assets/img/login-bg.jpg') top center/101% 100% no-repeat;
  min-height: 100vh;
  /* background-color: seagreen; */
}

#login {
  /* background-image: url(../assets/images/login/loginbg.png); */
  /* background-size: cover; */
  overflow: hidden;
  background-color: rgba(240, 244, 249, 1);
}

.login-div {
  height: 100%;
  text-align: center;
  font-size: 26px;

  .login-wrap {
    //background: url('../../assets/images/login/img-bg.png') top center/101% 100% no-repeat;
    height: 58.14%;
    box-sizing: border-box;
    padding-top: 50px;

    > img {
      width: 99px;
    }

    .form-text {
      color: #fff;
      text-align: center;
      margin-top: 23px;
      margin-bottom: 22px;
      font-size: 36px;
      font-family: Source Han Sans CN;
      font-weight: 500;
    }
  }

  .login-input-wrap {
    width: 23rem;
    background-color: #fff;
    margin: 24vh auto;
    padding-bottom: 30px;

    .input-wrap-bg-top {
      height: 30px;
      background: #409EFF;
    }

    .input-text {
      margin: 19px 0 5px;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #666666;
    }

    .input-user,
    .psdcls,
    .psdcls-getcode {
      margin-top: 20px;

      span {
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
        vertical-align: middle;
        margin-right: 16px;
      }

      /deep/ .el-input {
        vertical-align: middle;
        display: inline-block;
        width: 80%;

        .el-input__inner {
          padding: 0 15px;
        }
      }
    }

    .psdcls-getcode {
      display: flex;
      padding: 0 2.2rem;

      .get-code {
        padding: 0;
        flex-shrink: 0;
        width: 90px;
        text-align: center;
        font-size: 12px;
        font-weight: 400;
        color: #409EFF;
        margin-left: 1rem;
      }

      /deep/ .el-input {
        padding: 0;
      }
    }

    .input-bottom-wrap {
      margin: auto;
      margin-top: 20px;
      // text-align: left;
      width: 77%;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;

      span {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
        cursor: pointer;

      }
    }

    .loginbutton {
      margin: auto;
      margin-top: 27px;
      // height: 29px;
      // padding-bottom: 34px;
      width: 80%;

      /deep/ .el-button {
        width: 100%;
        //background: #005BBC;
        //border-color: #005BBC;
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        height: 100%;
      }
    }
  }
}
</style>
